export function isLegalPersonNif(nif: string): boolean {
    const nifRegex = /^\d{9}$/;
    if (!nifRegex.test(nif)) {
        return false;
    }

    const prefix = parseInt(nif.substring(0, 3), 10);

    return (prefix >= 900 && prefix <= 919) || (prefix >= 500 && prefix <= 599);
}
